<template>
    <div
        class="relative flex h-screen w-full overflow-hidden p-(--layout-padding-around-islands) [background:var(--layout-background-gradient-1),var(--layout-background-gradient-2),var(--layout-background-gradient-3)] before:pointer-events-none before:fixed before:top-0 before:left-0 before:z-(--layout-background-texture-z-index) before:h-full before:w-full before:bg-(image:--layout-background-texture) before:opacity-(--layout-background-texture-opacity) before:content-[''] max-tablet:p-0">
        <GlassSurface
            class="main-content-island flex h-full min-w-0 flex-1 flex-col overflow-hidden rounded-(--border-radius-xl) border-[0.063rem] border-solid border-(--white-alpha-12) border-t-(--white-alpha-18) border-l-(--white-alpha-18) shadow-[0_0.5rem_2rem_rgba(0,0,0,0.12)] z-10 max-tablet:rounded-none max-tablet:border-none">
            <header
                class="relative flex h-19.5 w-full shrink-0 items-center justify-between border-b-[0.063rem] border-solid border-b-(--white-alpha-15) px-8 bg-[linear-gradient(to_bottom,var(--white-alpha-65)_0%,var(--border-glass-subtle)_100%)]!">
                <div class="flex items-center justify-center gap-4">
                    <NuxtLink :to="HOME" class="flex items-center gap-2 no-underline">
                        <NuxtImg alt="EstimatorSystems" height="35" src="/images/logo.png" width="45" />
                        <span
                            class="text-[1.1rem] font-extrabold text-(--text-dark) font-(family-name:--primary-font) leading-[100%]">
                            Estimator
                        </span>
                    </NuxtLink>
                    <span
                        class="text-sm font-semibold text-gray-800 font-(family-name:--secondary-font) leading-[100%]">
                        AI Assistant
                    </span>
                </div>
            </header>

            <main
                class="flex-1 min-h-0 overflow-y-auto p-8 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-(--gray-alpha-50) [&::-webkit-scrollbar-track]:bg-transparent">
                <slot />
            </main>
        </GlassSurface>
    </div>
</template>

<script lang="ts" setup>
    import { HOME } from '@constants/routes';
    import { formatPageTitle } from '@utils/formatter';
    const { projectBasics } = useProjectWorkflowStates();
    useHead(() => ({
        title: formatPageTitle('AI Assistant', projectBasics.value?.name)
    }));
</script>
